"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoader = exports.Loader = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("@reactionable/core/lib/i18n/I18n");
const useLoader_1 = require("@reactionable/core/lib/ui/loader/useLoader");
const Spinner_1 = tslib_1.__importDefault(require("react-bootstrap/Spinner"));
const Loader = ({ overlay = true }) => {
    const { t } = I18n_1.useTranslation();
    const spinnerElement = (jsx_runtime_1.jsx(Spinner_1.default, Object.assign({ animation: "grow", role: "status", variant: "primary" }, { children: jsx_runtime_1.jsx("span", Object.assign({ className: "sr-only" }, { children: t("Loading") }), void 0) }), void 0));
    if (!overlay) {
        return spinnerElement;
    }
    return (jsx_runtime_1.jsx("div", Object.assign({ className: "spinner--overlay", style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            top: "50%",
            left: "50%",
        } }, { children: spinnerElement }), void 0));
};
exports.Loader = Loader;
const useLoader = (props = {}) => {
    return useLoader_1.useLoader(Object.assign(Object.assign({}, props), { Component: exports.Loader }));
};
exports.useLoader = useLoader;
//# sourceMappingURL=Loader.js.map